import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cuenta-corriente',
  templateUrl: './cuenta-corriente.component.html',
  styleUrls: ['./cuenta-corriente.component.css']
})
export class CuentaCorrienteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
